import { render, staticRenderFns } from "./NewTemplateCandidateItem.vue?vue&type=template&id=3669fb56"
import script from "./NewTemplateCandidateItem.vue?vue&type=script&lang=js"
export * from "./NewTemplateCandidateItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports